import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import routerSurface from './router/routerSurface.js'
import 'normalize.css/normalize.css'
import No from '@/components/no'
import Paging from '@/components/paging.vue';
import '@/assets/css/common.less'
import './styles/reset.less'
import './assets/font/iconfont.css'
import axios from './util/axios'
import api from './util/api'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'C7CFkH19rJW1ki0OqKeLj2LBgaPtTPYf' 
})
//生产环境
if (process.env.NODE_ENV == 'production') {
  console.log = function () {}
}
console.warn = function () {}
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.component('No', No)
Vue.component('Paging', Paging)
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.routerSurface = routerSurface
Vue.config.productionTip = false
Vue.config.silent = true
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
